import {
  prepareCustomerContractChangeSummary,
  setCustomerContractChangeBaseline,
} from '@changeTracking/pages/customerDetails/contractChangeTracking';
import {
  fetchCustomerContracts,
  updateCustomerContractCall,
} from '@store/customers/customerDetails/contracts';

import { customerDetailsStore } from '../store';
import { customerContractStore, setCustomerContract } from './store';

const getCustomerContracts = async (customerId: string) => {
  const resp = await fetchCustomerContracts(customerId, () =>
    setCustomerContract('isLoading', false),
  );
  if (resp) {
    setCustomerContract('customerContract', resp);
    setCustomerContractChangeBaseline(resp);
  }
};

const updateCustomerContract = async () => {
  if (customerContractStore.customerContract) {
    const payload = {
      ...customerContractStore.customerContract,
      customerId: customerDetailsStore.customer.id as number,
    };
    const { changedForms } = prepareCustomerContractChangeSummary(payload);
    const isSuccess = await updateCustomerContractCall(payload, changedForms);

    if (isSuccess) {
      setCustomerContractChangeBaseline(payload);
    }
    return Boolean(isSuccess);
  }
  return true;
};
export { getCustomerContracts, updateCustomerContract };
